import { createApp } from 'vue'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import Toast, { POSITION } from "vue-toastification";
import staticVars from './staticVars'
import * as COMMON_METHODS from './commonFunctions'
import vSelect from "vue-select";
import { defineRule,configure } from 'vee-validate';
// import AllRules from '@vee-validate/rules';
import * as AllRules from '@vee-validate/rules';
import VPagination from "@hennge/vue3-pagination";
//import Datepicker from 'vue3-date-time-picker';
import VueFeather from 'vue-feather';
import createPopper from '@popperjs/core';
import VScrollToTop from 'v-scroll-to-top'
import VueFloatLabel from 'vue-float-label'
import VOtpInput from "vue3-otp-input";
// import VueLazyLoad from 'vue3-lazyload'
//import vue3GoogleLogin from 'vue3-google-login'
import VueTelInput from 'vue3-tel-input'
import Datepicker from '@vuepic/vue-datepicker';
import Countdown from 'vue3-flip-countdown'
import snsWebSdk from '@sumsub/websdk';
import '@vuepic/vue-datepicker/dist/main.css';
// import VueCookies from 'vue3-cookies'
 import GoogleSignInPlugin from "vue3-google-signin"
 // import VueAppleLogin from 'vue-apple-login';
import GAuth from 'vue3-google-oauth2'
import { createI18n } from 'vue3-i18n'

import '../node_modules/bootstrap/dist/js/bootstrap.min.js'
//Css for npm packages
// import "vue-select/dist/vue-select.css";
// import "vue-toastification/dist/index.css";
// import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import 'vue3-marquee/dist/style.css'
import '../public/assets/css/font-awesome.min.css'
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import '../public/assets/css/style.css';
import '../public/assets/css/responsive.css';
import 'vue3-tel-input/dist/vue3-tel-input.css'

import header from './views/users/header.vue'

//Locales
import en from '../public/assets/locales/en.js'

import { max } from '@vee-validate/rules';
import { localize } from '@vee-validate/i18n';
// Define the rule globally
defineRule('max', max);
configure({
  // Generates an English message locale generator
  generateMessage: localize('en', {
    messages: {
      max: 'The  {field} cannot exceed 0:{max} characters.',
    },
  }),  
});




//Internationalization
const i18n = createI18n({
  locale: 'en',
  messages: {
    en,
  },
})

Object.keys(AllRules).forEach(rule => {
    defineRule(rule, AllRules[rule]);
});

defineRule('required', (value, t, ctx) => {
  if (!value || (value + '').trim() == '') {
    return ctx.field + ' field is required';
  }
  return true;
});
defineRule('onlyLetters', (value: any) => {
  if (!value || /^[A-Za-z]+$/.test(value)) {
    return true;
  }
  return 'This field must contain only alphabets';
});

const app = createApp(App)
// app.use(VueLazyLoad, {
//   loading: '',
//   error: '',
//   lifecycle: {
//     loading: (el) => {
//       console.log('loading', el)
//     },
//     error: (el) => {
//       console.log('error', el)
//     },
//     loaded: (el) => {
//       console.log('loaded', el)
//     }
//   }
// })

//Create global variables
app.config.globalProperties.static_vars = staticVars
app.config.globalProperties.COMMON = COMMON_METHODS

//Pinia store with persisted state
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

//Components for global use
app.use(VueFloatLabel)
app.use(pinia)
app.use(router)
app.use(VScrollToTop)
const filterBeforeCreate = (toast: { type: any }, toasts: { filter: (arg0: (t: any) => boolean) => { (): any; new(): any; length: number } }) => {
  if (toasts.filter((t: { type: any }) => t.type === toast.type).length !== 0) {
    return false;
  }
  return toast;
}
// app.use(Toast, {
//     position: 'top-right',
//     timeout: 3000,
//     hideProgressBar: true,
//     type: 'success'
// });
// app.use(VueCookies, {
//     path: ".finvasia.com",
//     secure: true,
// });
app.use(VueTelInput);
app.use(Countdown);
app.use(GoogleSignInPlugin, {
  clientId: `${process.env.VUE_APP_GOOGLE_CLIENT_ID}`,
});
// app.use(VueAppleLogin, {
//   clientId: 'com.zulutrade.ZuluTradeWeb',
//   redirectURI: 'https://dev.finvasia.com:8106/register/personal-details',
//   state: (new Date()).toString(),
//   usePopup: true,
// })
app.use(Toast, { filterBeforeCreate, position: POSITION.TOP_CENTER, transition: "Vue-Toastification__fade", });
app.component('v-select', vSelect)
app.component('v-paginate', VPagination)
//app.component('date-picker', Datepicker);
app.component(VueFeather.name, VueFeather);
app.component('v-otp-input', VOtpInput);
app.component('Header', header);
app.component('Datepicker', Datepicker);
app.use(i18n)
//App mounted
app.mount('#app')
